export default {
	race_alt: 'race',
	gold_coin_alt: 'gold coin',
	world_alt: 'World',
	races_banner_alt: 'Races Banner',
	races_banner_mobile_alt: 'Races Banner Mobile',
	vipclub_icon_alt: 'Vipclub Icon',
	// UI elements
	chip_button_image_alt: 'chip button image',
	error_alt: 'Error',
	chest_alt: 'chest',
	money_alt: 'money',
	usdt_alt: 'usdt',
	reward_alt: 'Reward',
	handle_icon_alt: 'handle icon',
	input_icon_alt: 'input icon',
	illustration_alt: 'illustration',
	reward_icon_alt: 'reward icon',
	arrow_left_alt: 'arrow left',
	arrow_right_alt: 'arrow right',
	banner_background_alt: 'banner background',
	promo_alt: 'promo',
	ellipse_alt: 'ellipse',
	orange_alt: 'orange',
	turnoff_alt: 'turnoff',
	icon_alt: 'icon',
	green_alt: 'green',
	rollback_icon_alt: 'rollback icon',
	shape_top_alt: 'Shape Top',
	shape_bottom_alt: 'Shape Bottom',
	edit_alias_alt: 'Edit Alias',
	loading_alt: 'loading',
	learn_more_img_alt: 'learn more',
	loading_mobile_alt: 'loading mobile',
	show_password_alt: 'Show password',
	logo_alt: 'logo',
	star_alt: 'star',
	avatar_alt: 'avatar',
	section_illustration_alt: 'section illustration',
	diamond_alt: 'diamond',
	vip_icons_alt: 'vip icons',
	cards_left_alt: 'cards left',
	chests_alt: 'chests',
	cards_right_alt: 'cards right',
	rakeboost_button_alt: 'Rakeboost Button',
	rakeboost_battery_alt: 'Rakeboost Battery',
	modal_header_alt: 'modal header',
	site_logo_alt: 'Site Logo',
	gold_coin_single_alt: 'Gold Coin',
	gold_coins_alt: 'Gold Coins',
	chest_and_gold_illustration_alt: 'chest and gold illustration',
	percentage_alt: 'percentage',
	// Crypto icons
	arb_alt: 'Arb',
	base_alt: 'Base',
	lightning_alt: 'Lightning',
	optimism_alt: 'Optimism',
	avax_alt: 'Avax',
	// Generic icons
	wallet_icon_alt: 'Wallet Icon',
	x_icon_alt: 'X Icon',
	dropdown_icon_alt: 'Dropdown Icon',
	warning_new_icon_alt: 'Warning New Icon',
	originals_icon_alt: 'Originals Icon',
	question_icon_alt: 'Question Icon',
	up_icon_alt: 'Up Icon',
	warning_icon_alt: 'Warning Icon',
	search_icon_alt: 'Search Icon',
	reddit_icon_alt: 'Reddit Icon',
	free_spins_icon_alt: 'Free Spins Icon',
	popular_icon_alt: 'Popular Icon',
	events_tickets_icon_alt: 'Events Tickets Icon',
	vip_header_icon_alt: 'Vip Header Icon',
	trash_icon_alt: 'Trash Icon',
	testimonials_icon_alt: 'Testimonials Icon',
	lock_icon_alt: 'Lock Icon',
	sports_icon_alt: 'Sports Icon',
	recently_tab_icon_alt: 'Recently Tab Icon',
	arrow_icon_alt: 'Arrow Icon',
	support_icon_alt: 'Support Icon',
	wallet_game_icon_alt: 'Wallet Game Icon',
	info_icon_alt: 'info icon',
	// Payment methods
	apple_pay_alt: 'Apple Pay',
	chips_alt: 'Chips',
	credit_card_alt: 'Credit Card',
	gpay_alt: 'GPay',
	mastercard_alt: 'MasterCard',
	visa_alt: 'Visa',
	// VIP section
	become_vip_alt: 'Become VIP',
	left_control_alt: 'Left control icon',
	right_control_alt: 'Right control icon',
	provider_logo_alt: 'Provider logo',
	// Banners & illustrations
	crypto_banner_alt: 'Crypto banner',
	spinner_alt: 'Spinner',
	reward_icon_image_alt: 'Reward Icon',
	join_now_alt: 'Arrow icon',
	banner_alt: 'Banner',
	// Referral & rewards
	referral_project_alt: 'Referral project',
	coin_alt: 'Coin',
	coin_bg_alt: 'Coin background',
	moneybox_alt: 'Moneybox',
	box_alt: 'Box',
	hat_illustration_alt: 'Hat illustration',
	how_it_works_illustration_alt: 'Astronauts in space suits promoting a referral bonus',
	invite_friends_banner_alt: 'Invite Friends Banner',
	top_arc_alt: 'Top Arc',
	bottom_arc_alt: 'Bottom Arc',
	unlock_alt: 'Unlock',
	card_background_alt: 'Card background',
	// Calendar & dates
	calendar_icon_alt: 'Calendar icon',
	// Level & progression
	level_up_alt: 'Level up',
	tier_card_img_alt: 'Tier card',
	person_alt: 'Person',
	// Chat & media
	selected_gif_alt: 'Selected GIF',
	close_icon_alt: 'Close icon',
	message_icon_alt: 'Message icon',
	option_user_icon_alt: 'Option user icon',
	selected_option_icon_alt: 'Selected option icon',
	// Misc
	hero_banner_alt: 'Hero Banner',
	meme_icon_alt: 'Meme icon',
	first_page_alt: 'First page',
	last_page_alt: 'Last page',
	no_transactions_illustration_alt: 'No transactions illustration',
	coming_soon_banner_alt: 'Coming soon banner',
	maintenance_alt: 'Maintenance',
	geoblock_alert_alt: 'Geoblock Alert',
	welcome_modal_illustration_alt: 'Welcome Modal Illustration',
	deposit_bonus_alt: 'Bonus',
	section_icon_alt: 'Section icon',
	step_image_alt: 'Step image'
};
